import axios from "axios";
import api from "services/api";
import type {
  CancelamentoTituloResponse,
  CancelarTituloPayload,
} from "../types/cancelamento-titulo.types";

function erroAxios(e: unknown): string {
  if (axios.isAxiosError(e)) {
    const data = e.response?.data as { error?: string } | undefined;
    if (data?.error && typeof data.error === "string") return data.error;
    if (e.response?.status === 403) return "Sem permissão para cancelar títulos.";
    return e.message || "Falha na requisição.";
  }
  return e instanceof Error ? e.message : "Falha na requisição.";
}

export async function cancelarTituloReceber(
  id: string,
  payload: CancelarTituloPayload,
): Promise<{ data: CancelamentoTituloResponse | null; status: number; error?: string }> {
  try {
    const res = await api.post<CancelamentoTituloResponse>(
      `/loja/financeiro/titulos-receber/${encodeURIComponent(id)}/cancelar`,
      payload,
    );
    return { data: res.data ?? null, status: res.status };
  } catch (e: unknown) {
    return {
      data: null,
      status: axios.isAxiosError(e) ? e.response?.status ?? 0 : 0,
      error: erroAxios(e),
    };
  }
}

export async function cancelarTituloPagar(
  id: string,
  payload: CancelarTituloPayload,
): Promise<{ data: CancelamentoTituloResponse | null; status: number; error?: string }> {
  try {
    const res = await api.post<CancelamentoTituloResponse>(
      `/loja/financeiro/titulos-pagar/${encodeURIComponent(id)}/cancelar`,
      payload,
    );
    return { data: res.data ?? null, status: res.status };
  } catch (e: unknown) {
    return {
      data: null,
      status: axios.isAxiosError(e) ? e.response?.status ?? 0 : 0,
      error: erroAxios(e),
    };
  }
}
